import "./component5.scss";
import React from "react";
import image_icon from "../../Images/image_icon.png";
import {
  ADDRESS_LINE,
  MAP_EMBED_SRC,
  MAP_LINK,
  METRO_LINES,
  PHONE_BOOKING_DISPLAY,
  PHONE_BOOKING_TEL,
  PHONE_MAIN_DISPLAY,
  PHONE_MAIN_TEL,
} from "../../constants/contact";

const Component5 = () => {
  return (
    <footer className="contact component5" id="contacts">
      <div className="container">
        <div className="contact__map-wrap">
          <iframe
            className="contact__map"
            title="Бильярдный клуб «ЛИГА» на карте"
            src={MAP_EMBED_SRC}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="contact__map-caption">
            <a href={MAP_LINK} target="_blank" rel="noreferrer">
              Открыть в Яндекс.Картах
            </a>
          </div>
        </div>

        <div className="contact__panel">
          <div className="contact__brand">
            <img src={image_icon} alt="" />
          </div>

          <div className="contact__cols">
            <div className="contact__col">
              <h3 className="contact__heading">Адрес</h3>
              <a className="contact__address" href={MAP_LINK} target="_blank" rel="noreferrer">
                {ADDRESS_LINE}
              </a>
              <ul className="contact__metro">
                {METRO_LINES.map((m) => (
                  <li key={m}>{m}</li>
                ))}
              </ul>
            </div>

            <div className="contact__col">
              <h3 className="contact__heading">Связь</h3>
              <p className="contact__microcopy">
                Бронирование столов и вопросы по меню — звоните в любое время
                работы клуба.
              </p>
              <div className="contact__cta-stack">
                <a className="cta-phone contact__cta" href={PHONE_BOOKING_TEL}>
                  Позвонить · {PHONE_BOOKING_DISPLAY}
                </a>
                <a className="cta-phone cta-phone--ghost contact__cta" href={PHONE_MAIN_TEL}>
                  {PHONE_MAIN_DISPLAY}
                </a>
              </div>
            </div>
          </div>

          <p className="contact__fineprint">
            © {new Date().getFullYear()} Бильярдный клуб «ЛИГА»
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Component5;
